import {
    GET_ADMIN_USER_LIST,
    GET_ADMIN_ASSOCIATED_ACCOUNT,
    GET_USER_ROLE,
    GET_ARDT_LIST,
    GET_ADMIN_ASSOCIATED_PHYSICIAN,
    GET_NEW_ASSIGNMENT,
    CLEAR_NEW_ASSIGNMENT,
    UPDATE_USER,
    ADD_ADMIN_PROXIES,
    GET_ADMIN_PROXY_LIST,
    REVOKE_ADMIN_PROXIES,
    IMPERSONATE_ADMIN_PROXY,
    UPDATE_ADMIN_PROXY,
    TERMINATE_ADMIN_PROXY,
    SET_UPDATE_POPUP,
    SET_ADMIN_SEARCH,
    SET_ADMIN_FILTER,
    SET_FILTER_PAGE,
    GET_ADMIN_DATA_FROM_SEARCH,
    CLEAR_SEARCH_RESULT,
    SET_SEARCH_TYPE,
    SET_ADMIN_SEARCH_PARAMS,
    SET_USER_ROLE_CHANGE,
    SET_LOGGED_USER_ROLE_CHANGE,
    GET_ADMIN_PROXY_USER_LIST,
    SHOW_LOCAL_EXPANDED_VIEW,
    SET_APPLIED_VIEW_ADMIN_FILTER,
    RESET_ROLES,
    RESET_TERRITORY,
    SET_CLEAR_FILTER,
    SET_FILTER_VIEW_ADMIN,
    SET_FILTER_TYPE,
    GET_SALES_ORG_VIEW,
    GET_DISTRICT,
    GET_TERRITORY,
    SET_ADMIN_FILTERS,
    SET_FILTER_PARAMS,
    SET_POPUPCLOSE_FROM_HEADER,
    SET_ADMIN_FILTER_PARAM_VALUES,
    SET_MORE_CLICK,
    GET_FILTER_DATA,
    SET_CHECKBOX_CHECKED,
    GET_ADMIN_USER_LIST_SEARCH,
    SET_SELECTED_SALESORG,
    SET_DEFAULT,
    SET_POP_DONE,
    SET_SALESORGVIEW_DATA,
    UPDATE_SALES_ORG,
    SET_SELECTED_VALUE,
    SET_FILTER_DETAILS,
    GET_FILTER_DETAILS,
    SET_SHOW_PROXY,
    SET_PROXYTAB_DATA,
    SET_TAB_ADMIN_PROXY,
    SET_FILER_AFTER_IMPERSONATION,
    CLEAR_ADMIN_FILTERS,
    CLEAR_ERROR_MESSAGE,
    SET_IMPERSONATION_STATUS,
    RESET_ARDT_LIST,
    SET_AREA,
    IS_SALES_ORG_INITIALIZED
} from 'src/pages/admin/redux/action/actionTypes.js';


export const getAdminUserList = (data, fromSearch, isDefault, selectedSalesOrgs) => {


    return {
        type: GET_ADMIN_USER_LIST,
        payload: data,
        fromSearch: fromSearch,
        isDefault: isDefault,
        selectedSalesOrg: selectedSalesOrgs


    };
};

export const getAdminUserListSearch = (data) => {
    return {type: GET_ADMIN_USER_LIST_SEARCH, payload: data};
};
export const setDefaultvalue = (data) => {
    return {type: SET_DEFAULT, payload: data};
};
export const getAdminAccountDetails = (payload) => {
    return {type: GET_ADMIN_ASSOCIATED_ACCOUNT, payload: payload};
};
export const updateSalesOrg = (payload) => {
    return {type: UPDATE_SALES_ORG, payload: payload};
};
export const getAdminPhysicianList = (payload) => {
    return {type: GET_ADMIN_ASSOCIATED_PHYSICIAN, payload: payload};
};

export const getUserRoles = (payload) => {
    return {type: GET_USER_ROLE, payload: payload};
};
export const setUserRolechange = (payload) => {
    return {type: SET_USER_ROLE_CHANGE, payload: payload};
};

export const setloggedUserRolechange = (payload) => {
    return {type: SET_LOGGED_USER_ROLE_CHANGE, payload: payload};
};

export const getARDTlist = (payload, area, region, district, subDistrict, territory, level4) => {
    return {
        type: GET_ARDT_LIST,
        payload: payload,
        area: area,
        region: region,
        district: district,
        territory: territory,
        subDistrict: subDistrict ? subDistrict : '',
        level4: level4 ? level4 : ''
    };
};

export const addProxies = (data) => {
    return {type: ADD_ADMIN_PROXIES, payload: data};
};

export const updateProxies = (data) => {
    return {type: UPDATE_ADMIN_PROXY, payload: data};
};

export const getProxyList = (payload) => {
    return {type: GET_ADMIN_PROXY_LIST, payload: payload};
};
export const setRevokeProxy = (data) => { 
    return {type: REVOKE_ADMIN_PROXIES, payload: data};
};
export const adminImpersonateProxy = (data) => {
    return {type: IMPERSONATE_ADMIN_PROXY, payload: data};
};
export const terminateAdminImpersonation = () => {
    return {type: TERMINATE_ADMIN_PROXY};
};
export const setAdminUpdatePopup = (payload) => {
    return {type: SET_UPDATE_POPUP, payload: payload};
};
export const getNewAssignment = (payload) => {
    return {type: GET_NEW_ASSIGNMENT, payload: payload};
};

export const clearNewAssignment = (payload) => {
    return {type: CLEAR_NEW_ASSIGNMENT, payload: payload};
};

export const updateUser = (payload) => {
    return {type: UPDATE_USER, payload: payload};
};

export const setAdminSearchOpen = (payload) => {
    return {type: SET_ADMIN_SEARCH, payload: payload};
};

export const setAdminFilterOpen = (payload) => {
    return {type: SET_ADMIN_FILTER, payload: payload};
};

export const getFilterData = (payload) => {
    return {type: GET_FILTER_DATA, payload: payload};
};

export const setFilterPage = (payload) => {
    return {type: SET_FILTER_PAGE, payload: payload};
};

export const getAdminDataSearch = (payload) => {
    return {type: GET_ADMIN_DATA_FROM_SEARCH, payload: payload};
};
export const clearSearchResult = () => {
    return {type: CLEAR_SEARCH_RESULT};
};
export const setSearchTypeAction = (payload) => {
    return {type: SET_SEARCH_TYPE, payload: payload};
};
export const setAdminSearchParams = (payload) => {
    return {type: SET_ADMIN_SEARCH_PARAMS, payload: payload};
};

export const getAdminProxyUsers = (payload) => {
    return {type: GET_ADMIN_PROXY_USER_LIST, payload: payload};
};

export const setShowLocalExpandedView = (updateView) => {
    return {type: SHOW_LOCAL_EXPANDED_VIEW, payload: updateView};
};

export const setClearFilter = (payload) => {
    return {type: SET_CLEAR_FILTER, payload: payload};
};

export const setFilterAppliedView = (payload) => {
    return {type: SET_FILTER_VIEW_ADMIN, payload: payload};
};
export const setPopupCloseFromHeader = (payload) => {
    return {type: SET_POPUPCLOSE_FROM_HEADER, payload: payload};
};

export const resetRoles = () => {
    return {type: RESET_ROLES};
};

export const resetTerritory = () => {
    return {type: RESET_TERRITORY};
};

export const setAppliedFilter = (appliedFilter) => {
    return {type: SET_APPLIED_VIEW_ADMIN_FILTER, payload: appliedFilter};
};
export const actionApplyFilterType = (filterType) => {
    return {type: SET_FILTER_TYPE, payload: filterType};
};

export const setAdminFilterParamValues = (payload) => {
    return {type: SET_ADMIN_FILTER_PARAM_VALUES, payload: payload};
};

export const getDistrict = (data) => { 
    return {type: GET_DISTRICT, payload: data};
};

export const getSalesOrgView = (data) => {
    return {type: GET_SALES_ORG_VIEW, payload: data};
};

export const setAdminFilters = (payload) => {
    return {type: SET_ADMIN_FILTERS, payload: payload};
};

export const getTerritory = (district) => {
    return {type: GET_TERRITORY, payload: district};
};

export const setAdminFilterParams = (payload) => {
    return {type: SET_FILTER_PARAMS, payload: payload};
};
export const setSelectedViews = (payload) => {
    return {type: SET_SELECTED_VALUE, payload: payload};
};
export const setMoreClick = (payload) => {
    return {type: SET_MORE_CLICK, payload: payload};
};

export const setCheckBoxChecked = (payload) => {
    return {type: SET_CHECKBOX_CHECKED, payload: payload};
};

export const setPopDone = (payload) => {
    return {type: SET_POP_DONE, payload: payload};
};

export const setSelectedSalesOrg = (data) => {
    return {type: SET_SELECTED_SALESORG, payload: data};
};

export const setSalesOrgViewData = (data) => {
    return {type: SET_SALESORGVIEW_DATA, payload: data};
};

export const setFilterDetails = (data) => {
    return {type: SET_FILTER_DETAILS, payload: data};
};

export const getFilterDetails = (data) => {
    return {type: GET_FILTER_DETAILS, payload: data};
};
export const setshowProxy = (payload) => {
    return {type: SET_SHOW_PROXY, payload: payload};
};
export const setProxyTabData = (payload) => {
    return {type: SET_PROXYTAB_DATA, payload: payload};
};
export const setAccountTabActiveId = (payload) => {
    return {type: SET_TAB_ADMIN_PROXY, payload: payload};
};

export const setFilterAfterImpersonation = (payload) => {
    return {type: SET_FILER_AFTER_IMPERSONATION, payload: payload};
};

export const clearAdminFilters = (payload) => {
    return {type: CLEAR_ADMIN_FILTERS, payload: payload};
};
export const clearErrorMessage = (payload) => {
    return {type: CLEAR_ERROR_MESSAGE, payload: payload};
};
export const setImpersonationStatus = () => {
    return {type: SET_IMPERSONATION_STATUS};
};

export const resetARDTList = () => {
    return {type: RESET_ARDT_LIST};
};

export const setArea = (payload) => {
    return {type: SET_AREA, payload: payload};
};

export const setSalesOrgInitialized = () => {
    return {type: IS_SALES_ORG_INITIALIZED, payload: true};
};
